import React, { useCallback, useEffect, useState } from 'react';
import { makeStyles, Theme } from '@material-ui/core';

interface Props {
  startTime: number;
}

const CallDuration = (props: Props) => {
  const { startTime } = props;
  const [clock, setClock] = useState('0:00');
  const classes = useStyles();

  const getClock = useCallback(() => {
    const seconds = Math.round((Date.now() - startTime) / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(seconds / (60 * 60));
    const strHour = String(hours);
    const strMin = String(`00${minutes % 60}`).slice(-2);
    const strSec = String(`00${seconds % 60}`).slice(-2);

    if (hours) {
      return `${strHour}:${strMin}:${strSec}`;
    }
    return `${minutes % 60}:${strSec}`;
  }, [startTime]);

  useEffect(() => {
    if (!startTime) return;
    const intervalId = setInterval(() => setClock(getClock), 1000);

    return function componentWillUnmount() {
      clearInterval(intervalId);
    };
  }, [getClock, startTime]);

  return (
    <div className={classes.container}>
      <span data-testid="callDuration">{clock}</span>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    fontFamily: `Monaco, 'Courier New', Courier, 'Lucida Console', ${theme.typography.fontFamily}`,
    padding: `0 ${theme.spacing(1)}px`
  }
}));

export default CallDuration;
